module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.content.title,
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form,
      "rules": _vm.fields.validation
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "created_at",
      "label": "Date et heure du commentaire"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-control",
    attrs: {
      "type": "datetime",
      "placeholder": "Selectionnez une date et une heure",
      "picker-options": _vm.fields.created_at,
      "format": "dd/MM/yyyy à HH:mm"
    },
    model: {
      value: (_vm.form.created_at),
      callback: function($$v) {
        _vm.$set(_vm.form, "created_at", $$v)
      },
      expression: "form.created_at"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "customer_id",
      "label": "Client"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchCustomer,
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.customer_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_id", $$v)
      },
      expression: "form.customer_id"
    }
  }, _vm._l((_vm.fields.customers), function(customer) {
    return _c('customer', {
      key: customer.id,
      attrs: {
        "item": customer,
        "present": "option"
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.form.description = _vm.bold('comment_comment')
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-format-bold"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "description",
      "label": "Description"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "comment_comment",
      "type": "textarea",
      "autosize": "",
      "placeholder": "Saisissez la description de votre commentaire"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.advanced = !_vm.advanced
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  }), _vm._v(" Plus d'options\n      ")])], 1), _vm._v(" "), (_vm.advanced) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Commercial",
      "prop": "user_id"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.user_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_id", $$v)
      },
      expression: "form.user_id"
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.name,
        "value": user.id
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.form.id !== null) ? _c('el-button', {
    directives: [{
      name: "delete",
      rawName: "v-delete:comment",
      value: (this.form),
      expression: "this.form",
      arg: "comment"
    }],
    staticClass: "pull-left",
    attrs: {
      "type": "danger",
      "plain": true
    }
  }, [_vm._v("Supprimer")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.content.button_type
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.content.button))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bdf0e01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/CommentModal.vue
// module id = 687
// module chunks = 1